<div class="card kpi-red">
    <div class="card-body kpi-card">
        <h5 class="card-title">Prix au m²</h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €/m²</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.price / favorite.square  | number:'1.0-0'  }} €/m²
            </ng-container>
        </p>
    </div>
</div>
